// Dependecies
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'antd/dist/antd.css';
import { useTranslation } from 'react-i18next';

// Component
import Template from '../../components/Template';
import FixedJobRequest from '../../components/JobRequest';
// Hooks
import useNotificationRead from '../../hooks/useNotificationRead';

// Images
import planes from '../../../sass/images/ilustracion-planes.svg';
import pin from '../../../sass/images/pin2.svg';

// Utils
import { contactEmail } from '../../helpers';

function PlansCompany() {
  const { newMaintenancesCompany } = useNotificationRead();
  const { t } = useTranslation(['plans', 'alert', 'alt']);
  return (
    <Template
      type={4}
      newMaintenances={newMaintenancesCompany}
      classNameContainer="plans"
      className="container_menu plans"
    >
      <FixedJobRequest />
      <div className="content_dynamic plans_content">
        <Row className="no-gutters">
          <Col sm={12} md={12} lg={12} xl={6} className="img-plans">
            <img className="img-plan" src={planes} alt={t('alt:plans_ilustration')} />
          </Col>
          <Col sm={12} md={12} lg={12} xl={6} className="text-plans">
            <h1>{t('tittle')}</h1>
            <hr className="spacy-x1" />
            <h2>{t('text1')}</h2>
            <hr className="spacy-x2" />
            <p className="txt-plan">{t('text2')}</p>
            <hr className="spacy-x2" />
            <p className="txt-plan-cursive">
              {t('text3')}
              <b>
                <a href={`mailto:${contactEmail()}`}>
                  <strong> {contactEmail()} </strong>
                </a>
              </b>
              {t('text4')}
            </p>
            <div className="grid-imag">
              <img src={pin} alt={t('alt:location')} />
            </div>
          </Col>
        </Row>
      </div>
    </Template>
  );
}

export default PlansCompany;
